import React from 'react';
import styled from 'styled-components';
import IconInfoSvg from '@catalogo/ui-americanas-desktop-svg/icon-info.svg';

export const Alert = () => (
  <Component>
    <IconInfoUI />
    <div>
      <strong>O Ministério da Saúde informa</strong>
      <p>O aleitamento materno evita infecções e alergias e é recomendado até os 2 (dois) anos de idade ou mais.</p>
    </div>
  </Component>
);

const Component = styled.div`
  min-height: 88px;
  padding: 16px;
  display: flex;
  align-items: flex-start;
  font-size: 14px;
  line-height: 16px;
  font-weight: 700;
  max-width: 408px;
  border-radius: 8px;
  margin-bottom: 16px;
  color: ${({ theme }) => theme.grey.darker};
  background-color: ${({ theme }) => theme.info.light};
  font-family: ${({ theme }) => theme.fontFamily};

  strong {
    display: block;
    margin-bottom: 4px;
  }

  @media (min-width: 700px) {
    margin-bottom: 0px;
  }
`;

const IconInfoUI = styled(IconInfoSvg)`
  width: 40px;
  height: 20px;
  margin-right: 16px;
`;

export default Alert;
